export interface Device {
    _id: string;
    organizationId: string;
    siteId: string;
    uid: string;
    name: string;
    notes: string;
    type: DeviceType;
    subject: Compressor // | Telematic;
    updatedAt?: string | undefined;
    createdAt?: string | undefined;
    deletedAt?: string | undefined;
}

export enum DeviceType {
    Summit = 'summit',
    SummitCompressor = 'summit-compressor',
    Bloom = 'bloom',
    Pulse = 'pulse', // Update to pulse in the future maybe.
}

export interface Compressor {
    compressorType: string;
    horsepower: string;
    serialNumber: string;
    refrigerant: string;
    _id: string;
}